import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.less';
import TableHeader from './table-header';
import TableRow from './table-row';

const InventoryLevelsTable = ({ groupedConnectionCounts }) => {
  return (
    <div className={style['grid-container']}>
      <TableHeader />
      {Object.keys(groupedConnectionCounts).map((key) => {
        return groupedConnectionCounts[key].map((counts, index) => {
          return (
            <TableRow
              key={index}
              counts={counts}
              isFirstInGroup={index === 0}
              isGroupFooter={index === groupedConnectionCounts[key].length - 1}
            />
          );
        });
      })}
    </div>
  );
};

InventoryLevelsTable.propTypes = {
  groupedConnectionCounts: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        allocatedQuantity: PropTypes.number.isRequired,
        availableQuantity: PropTypes.number.isRequired,
        committedQuantity: PropTypes.number.isRequired,
        connectionId: PropTypes.string.isRequired,
        connectionName: PropTypes.string.isRequired,
        connectionStatus: PropTypes.string.isRequired,
        isConnectionIncluded: PropTypes.bool.isRequired,
        connectionType: PropTypes.string.isRequired,
        lastUpdated: PropTypes.string.isRequired,
        onhandQuantity: PropTypes.number.isRequired,
      }),
    ),
  ).isRequired,
};

export default InventoryLevelsTable;
